import type { Locale } from "@/lib/i18n";

import { AR_PROSE } from "./prose.ar";
import { FA_PROSE } from "./prose.fa";
import type { Section } from "./reference";

const CATALOGUES: Record<Locale, Record<string, string>> = { en: {}, fa: FA_PROSE, ar: AR_PROSE };

export type Prose = (key: string, fallback: string) => string;

export function proseFor(locale: Locale): Prose {
  const catalogue = CATALOGUES[locale];
  return (key, fallback) => catalogue[key] ?? fallback;
}

export function localise(section: Section, prose: Prose): Section {
  const out: Section = {
    ...section,
    title: prose(`section.${section.id}.title`, section.title),
    intro: prose(`section.${section.id}.intro`, section.intro),
  };
  if (section.endpoints !== undefined) {
    out.endpoints = section.endpoints.map((endpoint) => {
      const key = `${endpoint.method} ${endpoint.path}`;
      const next = { ...endpoint, summary: prose(key, endpoint.summary) };
      if (endpoint.notes !== undefined) next.notes = prose(`${key}#note`, endpoint.notes);
      return next;
    });
  }
  if (section.events !== undefined) {
    out.events = section.events.map((event) => ({
      ...event,
      summary: prose(`event.${event.name}`, event.summary),
    }));
  }
  if (section.code !== undefined) {
    out.code = section.code.map((block) => ({
      ...block,
      caption: prose(`code.${block.caption}`, block.caption),
    }));
  }
  return out;
}
